// import React from "react";
// import "./Components/EndTest.css";
// import {Link} from 'react-router-dom';
// const EndTest = () => {
//   return (
//     <div className="endtest-container">
//       <div className="endtest-box">
//         <div className="student-info">
//           <p><strong>Student Name :</strong> Yash Yadav</p>
//           <p><strong>Std :</strong> 5th</p>
//           <p><strong>Subject :</strong> Marathi</p>
//         </div>
//         <hr />
//         <div className="end-message">
//           <h2>End of Test....!</h2>
//           <p>Well done! You finished the test</p>
//           <p>Check your answers now. Keep learning and have fun!</p>
//           <Link to ="/TestReview" className="review-btnend">Review Test</Link>
          
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EndTest;



// import React from "react";
// import "./Components/EndTest.css";
// import {Link} from 'react-router-dom';

// const EndTest = () => {
//   // Retrieve stored answers and questions
//   const studentAnswers = JSON.parse(localStorage.getItem("studentAnswers")) || {};
//   const questions = JSON.parse(localStorage.getItem("examQuestions")) || [];
  
//   // Calculate score
//   const score = questions.reduce((acc, question) => {
//     if (studentAnswers[question.id] === question.correctAnswer) {
//       return acc + 1;
//     }
//     return acc;
//   }, 0);

//   return (
//     <div className="endtest-container">
//       <div className="endtest-box">
//         <div className="student-info">
//           <p><strong>Student Name :</strong> Yash Yadav</p>
//           <p><strong>Std :</strong> 5th</p>
//           <p><strong>Subject :</strong> Marathi</p>
//           <p><strong>Score :</strong> {score}/{questions.length}</p>
//         </div>
//         <hr />
//         <div className="end-message">
//           <h2>End of Test....!</h2>
//           <p>Well done! You finished the test</p>
//           <p>Check your answers now. Keep learning and have fun!</p>
//           <Link 
//             to="/TestReview" 
//             className="review-btnend"
//             state={{ questions, answers: studentAnswers }}
//           >
//             Review Test
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EndTest;



import React from "react";
import "./Components/EndTest.css";
import { Link, useLocation } from "react-router-dom"; // Import useLocation

const EndTest = () => {
  const location = useLocation();

  // Prioritize data from location.state if available (from ExamQuestion)
  // Otherwise, fall back to localStorage.
  const questions = location.state?.questions || JSON.parse(localStorage.getItem("examQuestions")) || [];
  const studentAnswers = location.state?.answers || JSON.parse(localStorage.getItem("studentAnswers")) || {};

  // Calculate score based on the definitively retrieved questions and answers
  const score = questions.reduce((acc, question) => {
    // Ensure both are defined and trim for accurate comparison
    if (studentAnswers[question.id] && question.correctAnswer && studentAnswers[question.id].trim() === question.correctAnswer.trim()) {
      return acc + 1;
    }
    return acc;
  }, 0);

  return (
    <div className="endtest-container">
      <div className="endtest-box">
        <div className="student-info">
  <p>
    <strong>Student Name:</strong> Yash Yadav &nbsp; 
    <strong>Std:</strong> 5th &nbsp; 
    <strong>Subject:</strong> Marathi &nbsp;
    {/* /<strong>Score:</strong> {score}/{questions.length} */}
  </p>
</div>

  <div className="Insruction-bx-endtest">
        <div className="end-message">
          <h2>End of Test....!</h2>
          <p>Well done! You finished the test</p>
          <p>Check your answers now. Keep learning and have fun!</p>
          <Link
            to="/TestReview"
            className="review-btnend"
            // CRITICAL: Pass the same 'questions' and 'studentAnswers' data that EndTest used
            state={{ questions: questions, answers: studentAnswers }}
          >
            Review Test
          </Link>
        </div>
        </div>
      </div>
    </div>
  );
};

export default EndTest;